import {isAfter, parseISO} from 'date-fns';

import type {TestDriveResponseBody} from '@dms/api/sales';

import type {BusinessCasePlannedActivity} from '@prompt-bridge/shared/ai-assistant-core';

export const toUpcomingBusinessCaseTestDrivePlannedActivities = (
  testDrives: readonly TestDriveResponseBody[],
  evaluatedAt: string
): BusinessCasePlannedActivity[] =>
  testDrives.flatMap((testDrive) =>
    testDrive.state === 'planned' && isAfter(parseISO(testDrive.scheduledAt), parseISO(evaluatedAt))
      ? [
          {
            id: testDrive.id,
            kind: 'testDrive' as const,
            dueAt: testDrive.scheduledAt,
            completed: false,
          },
        ]
      : []
  );
